import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import ResidentEmitAdd from './components/ResidentEmitAdd';


const { Cell } = ResponsiveGrid;

const ResidentEmit = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="社區訊息推播"
        // description="住戶建立戶號"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '社區訊息推播',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <ResidentEmitAdd />
    </Cell>

    
  </ResponsiveGrid>
);

export default ResidentEmit;
